<ion-app>
  <ion-header
    [hidden]="(shouldDisplayHeader$ | async) !== true"
  >
    <app-header></app-header>
  </ion-header>
  <ion-content>
    <ion-router-outlet></ion-router-outlet>
  </ion-content>
  <ion-footer *ngIf="(shouldDisplayFooter$ | async) === true">
    <app-navigation-bar></app-navigation-bar>
  </ion-footer>
</ion-app>

<!-- <app-debug *ngIf="isDevMode"></app-debug> -->
